import "bootstrap/dist/css/bootstrap.min.css"
import "./i18n/i18n"
import "./index.css"
import "./text-editor.css"

import { registerLicense } from "@syncfusion/ej2-base"
import { QueryClientProvider } from "@tanstack/react-query"
import ReactDOM from "react-dom/client"

import App from "./App"
import { queryClient } from "./queries/queries"

registerLicense(
  "Ngo9BigBOggjHTQxAR8/V1NBaF1cXmhMYVJ/WmFZfVpgd19FZFZTRWY/P1ZhSXxXdkBiW35bc3BXR2lYVkw="
)

ReactDOM.createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
)
